module.exports = __webpack_public_path__ + "static/media/VectorMapDetail.fea27e21.svg";